import React from 'react';
import Button from 'shared/components/button/Button';
import { Formik, Form, Field } from 'formik';

const MessageTyping = ({ sendMessage }) => {
  const contentFieldName = 'message';

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        message: ''
      }}
      onSubmit={(values, actions) => {
        var content = values[contentFieldName].trim();
        content && sendMessage(content, {});
        actions.setFieldValue(contentFieldName, '');
      }}
    >
      {() => (
        <Form>
          <div className="message-typing">
            <div className="form-group">
              <Field name={contentFieldName}>
                {({ field }) => (
                  <input
                    type="text"
                    {...field}
                    placeholder="Type your message"
                    className="form-control"
                    autoComplete="off"
                  />
                )}
              </Field>
            </div>
            <Button type="submit" color="info" label="Send" />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default MessageTyping;
